var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 110.083,
    viewBox: "0 0 153 110.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1,.prefix__cls-2{fill:none;stroke:#000;stroke-miterlimit:10}.prefix__cls-1{stroke-width:6px}.prefix__cls-2{stroke-width:4px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_15",
    "data-name": "Group 15",
    transform: "translate(2.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_14",
    "data-name": "Group 14",
    transform: "translate(27.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_18",
    d: "M72.752 108.551h-2.416c-2.347-1-4.694-1.971-7.03-3-17.478-7.721-29.385-20.369-34.228-39.123-4.011-15.553-3.316-31.4-2.7-47.228a4.472 4.472 0 012.074-2.928c.923-.558 2.313-.422 3.509-.456 13.092-.4 24.987-3.988 34.946-12.875C68.035 1.948 69.2.98 70.336 0h2.416c2.723 2.222 5.332 4.615 8.192 6.643 9.309 6.62 19.928 8.956 31.151 9.184 3.338.068 4.637 1.117 4.729 4.09.422 12.773.8 25.546-1.105 38.261-2.928 19.552-12.294 34.775-29.944 44.322-4.193 2.28-8.675 4.046-13.023 6.051zm-39.025-85.3c0 8.318-.08 16.271.046 24.212a83.408 83.408 0 00.855 8.375C37.18 77.457 48.961 91.848 69 99.8a6.139 6.139 0 004.991.057c17.08-6.871 28.918-18.379 33.2-36.792 3.019-13 2.359-26.161 2.108-39.321 0-.125-.171-.251-.365-.524-13.924-.627-26.617-4.854-37.4-14.3-10.826 9.504-23.541 13.697-37.807 14.335z",
    "data-name": "Path 18",
    transform: "translate(-25.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_19",
    d: "M63.032 54.764C68.9 48.851 74.495 43.211 80.1 37.571c2.7-2.712 4.763-3.168 6.6-1.424 1.937 1.834 1.55 3.931-1.288 6.768Q76.027 52.3 66.644 61.669c-2.8 2.792-4.307 2.78-7.11 0q-4.529-4.512-9.036-9.036c-2.074-2.1-2.256-4.216-.558-5.879 1.641-1.618 3.885-1.436 5.914.6 2.381 2.363 4.683 4.812 7.178 7.41z",
    "data-name": "Path 19",
    transform: "translate(-22.714 4.895)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20",
    d: "M91 76h36.461v13.673",
    className: "prefix__cls-1",
    "data-name": "Path 20",
    transform: "translate(10.407 10.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_21",
    d: "M33.067 30.673H8V17",
    className: "prefix__cls-1",
    "data-name": "Path 21",
    transform: "translate(-1.164 2.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_22",
    d: "M35.974 66H11.67v12.533",
    className: "prefix__cls-1",
    "data-name": "Path 22",
    transform: "translate(-.652 9.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_23",
    d: "M104.67 38.533h24.3V26",
    className: "prefix__cls-1",
    "data-name": "Path 23",
    transform: "translate(12.313 3.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_3",
    d: "M0 0L10.631 0",
    className: "prefix__cls-1",
    "data-name": "Line 3",
    transform: "translate(113.565 64.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_4",
    d: "M0 0L5.697 0",
    className: "prefix__cls-1",
    "data-name": "Line 4",
    transform: "translate(22.788 53.621)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_15",
    cx: 7,
    cy: 7,
    r: 7,
    className: "prefix__cls-2",
    "data-name": "Ellipse 15",
    transform: "translate(-.452 4.083)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_16",
    cx: 5,
    cy: 5,
    r: 5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 16",
    transform: "translate(132.548 98.083)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_17",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 17",
    transform: "translate(6.548 87.083)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_18",
    cx: 7,
    cy: 7,
    r: 7,
    className: "prefix__cls-2",
    "data-name": "Ellipse 18",
    transform: "translate(134.548 18.083)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_19",
    cx: 4.558,
    cy: 4.558,
    r: 4.558,
    className: "prefix__cls-2",
    "data-name": "Ellipse 19",
    transform: "translate(124.195 59.785)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_20",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-2",
    "data-name": "Ellipse 20",
    transform: "translate(13.548 49.083)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.67c4c6ceaf881b09d89af0049c3672bb.svg";
export { ForwardRef as ReactComponent };